import PeNotes from '../../components/PeNotes';
import PePersonalise from '../../components/PePersonalise';
import PeSelectBox from '../../components/PeSelectBox';
import PeSingleChoice from '../../components/PeSingleChoice';
import PeTextArea from '../../components/PeTextArea';

const option = {
    yes_no: [{
        label: "Yes",
        value: "yes"
    }, {
        label: "No",
        value: "no"
    }],
    prepared_by: [
        {
            label: 'Paul Szuster',
            value: 'Paul Szuster',
        },
        {
            label: 'Matthew Wright',
            value: 'Matthew Wright',
        },
        {
            label: 'PE Admin',
            value: 'PE Admin',
        },
    ],
}

export const quoteSummaryField = [
{
    name: 'note_select',
    dependOn: "{\"product_choice\": \"\", \"indicative_pricing\":\"yes\"}",
    component: PeSingleChoice,
    props: {
        label: 'Add any notes ?',
        required: true,
        options: option.yes_no,
        sm: 2,
    },
},
{
    name: 'customer_note',
    dependOn: "{\"product_choice\": \"\", \"note_select\":\"yes\"}",
    dependOnValue: 'yes',
    component: PeTextArea,
    props: {
        label: 'Customer Notes',
    }
},
{
    name: 'pe_note',
    dependOn: "{\"product_choice\": \"\", \"indicative_pricing\":\"yes\"}",
    component: PeNotes,
    props: {}
},
{
    name: 'personal_info',
    dependOn: "{\"product_choice\": \"\", \"note_select\":\"\"}",
    component: PePersonalise,
    props: {
        label: 'Personalise Your Quotes',
        required: true,
    },
},
{
    name: 'hear_about',
    dependOn: "{\"product_choice\": \"\", \"your_email\":\"\", \"note_select\":\"\"}",
    component: PeSelectBox,
    props: {
        label: 'Where did you hear about us?',
        required: true,
        options: undefined,
        source: 'leadSource',
        sm: 4,
    },
},
{
    name: 'prepared_by',
    dependOn: 'hear_about',
    component: PeSingleChoice,
    props: {
        label: 'Pure Electric Sales Consultant:',
        required: true,
        options: option.prepared_by,
    },
},
{
    name: 'send_sms',
    component: PeSingleChoice,
    dependOn: "{\"prepared_by\": \"\", \"hear_about\":\"\"}",
    props: {
        label: 'Quote via SMS?',
        options: option.yes_no,
        required: true,
        sm: 2,
    },
},
{
    name: 'sms_template',
    dependOn: 'send_sms',
    dependOnValue: 'yes',
    props: {
        required: true,
        isAuth: true,
    },
    component: PeTextArea
},
]
